


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// const API =
//   process.env.NODE_ENV === "production"
//     ? "https://luckydraw.hoppersdome.com/api/coupons"
//     : "https://luckydraw.hoppersdome.com/api/coupons";

// export default function LotteryRegistration() {
//   const { ref } = useParams();

//   const [form, setForm] = useState({
//     receiver_name: "",
//     receiver_aadhaar: "",
//     receiver_address: "",
//     receiver_mobile: "",
//     giver_name: "",
//     giver_mobile: "",
//     giver_address: "",
//     payment_cash: false,
//     payment_online: false,
//   });

//   const [screenshot, setScreenshot] = useState(null);
//   const [error, setError] = useState("");
//   const [successData, setSuccessData] = useState(null);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const update = (field, value) =>
//     setForm((prev) => ({ ...prev, [field]: value }));

//   /* ================= PREFILL (CHAIN LOGIC) ================= */
//   useEffect(() => {
//     if (!ref) return;

//     axios.get(`${API}/prefill/${ref}`)
//       .then((res) => {
//         if (res.data.success) {
//           setForm((prev) => ({
//             ...prev,
//             giver_name: res.data.giver.giver_name,
//             giver_mobile: res.data.giver.giver_mobile,
//             giver_address: res.data.giver.giver_address,
//           }));
//         }
//       })
//       .catch(() => {});
//   }, [ref]);

//   /* ================= VALIDATION ================= */
//   const validateForm = () => {
//     setError("");

//     const required = [
//       "receiver_name",
//       "receiver_address",
//       "receiver_mobile",
//       "giver_name",
//       "giver_mobile",
//       "giver_address",
//     ];

//     for (let f of required) {
//       if (!form[f]) {
//         setError("कृपया सर्व आवश्यक माहिती भरा.");
//         return false;
//       }
//     }

//     if (!/^\d{10}$/.test(form.receiver_mobile)) {
//       setError("Receiver mobile must be 10 digits.");
//       return false;
//     }

//     if (!/^\d{10}$/.test(form.giver_mobile)) {
//       setError("Giver mobile must be 10 digits.");
//       return false;
//     }

//     if (!/^\d{12}$/.test(form.receiver_aadhaar)) {
//       setError("कृपया 12 अंकी आधार क्रमांक प्रविष्ट करा.");
//       return false;
//     }

//     if (!form.payment_cash && !form.payment_online) {
//       setError("Please select payment method.");
//       return false;
//     }

//     if (!screenshot) {
//       setError("कृपया पेमेंटचा स्क्रीनशॉट अपलोड करा.");
//       return false;
//     }

//     return true;
//   };

//   /* ================= SUBMIT ================= */
//   const submitForm = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);

//       const fd = new FormData();
//       Object.keys(form).forEach((key) => fd.append(key, form[key]));
//       fd.append("screenshot", screenshot);

//       const url = ref ? `${API}/register/${ref}` : `${API}/register`;

//       const res = await axios.post(url, fd);

//       if (res.data.success) {
//         setSuccessData(res.data);
//         setShowSuccessPopup(true);
//       } else {
//         setError(res.data.message);
//       }

//     } catch (err) {
//       setError(err.response?.data?.message || "Server error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= COPY LINK ================= */
//   const copyLink = () => {
//     if (!successData?.referral_link) return;

//     navigator.clipboard.writeText(successData.referral_link);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   return (
//     <>
//       {/* SUCCESS POPUP */}
//       {showSuccessPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-xl w-80 text-center">
//             <h2 className="text-xl font-bold text-green-600 mb-2">
//               ✔️ फॉर्म सबमिट झाला!
//             </h2>

//             <p className="text-gray-700 text-sm">
//               आपला फॉर्म यशस्वीरीत्या सबमिट झाला आहे.
//               मंजुरीनंतर तुम्हाला SMS येईल.
//             </p>

//             <div className="text-2xl font-bold text-blue-600 mt-3">
//               {successData?.coupon_number}
//             </div>

//             <div className="text-xs bg-gray-100 p-2 break-all mt-2">
//               {successData?.referral_link}
//             </div>

//             <button
//               onClick={copyLink}
//               className="bg-blue-600 text-white px-4 py-2 rounded w-full mt-3"
//             >
//               Referral Link Copy करा
//             </button>

//             {copied && (
//               <p className="text-green-600 text-sm mt-1">
//                 Link Copied!
//               </p>
//             )}

//             <button
//               onClick={() => setShowSuccessPopup(false)}
//               className="mt-3 bg-green-600 text-white px-4 py-2 rounded w-full"
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}

//       {/* MAIN FORM */}
//       <div className="border p-4 space-y-3 text-sm bg-white shadow rounded max-w-md mx-auto mt-6">

//         {error && <p className="p-2 bg-red-200">{error}</p>}

//         <div>
//           <label>कुपन घेणाऱ्याचे नाव / Receiver Name</label>
//           <input
//             className="border p-1 w-full"
//             value={form.receiver_name}
//             onChange={(e) => update("receiver_name", e.target.value)}
//           />
//         </div>

//         <div>
//           <label>आधार क्रमांक / Aadhaar</label>
//           <input
//             maxLength={12}
//             className="border p-1 w-full"
//             value={form.receiver_aadhaar}
//             onChange={(e) =>
//               update("receiver_aadhaar", e.target.value.replace(/\D/g, ""))
//             }
//           />
//         </div>

//         <div>
//           <label>पत्ता / Address</label>
//           <input
//             className="border p-1 w-full"
//             value={form.receiver_address}
//             onChange={(e) => update("receiver_address", e.target.value)}
//           />
//         </div>

//         <div>
//           <label>मो. नं. / Mobile</label>
//           <input
//             maxLength={10}
//             className="border p-1 w-full"
//             value={form.receiver_mobile}
//             onChange={(e) =>
//               update("receiver_mobile", e.target.value.replace(/\D/g, ""))
//             }
//           />
//         </div>

//         <div>
//           <label>कुपन देणाऱ्याचे नाव / Giver Name</label>
//           <input
//             disabled={!!ref}
//             className="border p-1 w-full bg-gray-100"
//             value={form.giver_name}
//             onChange={(e) => update("giver_name", e.target.value)}
//           />
//         </div>

//         <div>
//           <label>मो. नं. / Giver Mobile</label>
//           <input
//             maxLength={10}
//             disabled={!!ref}
//             className="border p-1 w-full bg-gray-100"
//             value={form.giver_mobile}
//             onChange={(e) =>
//               update("giver_mobile", e.target.value.replace(/\D/g, ""))
//             }
//           />
//         </div>

//         <div>
//           <label>पत्ता / Giver Address</label>
//           <input
//             disabled={!!ref}
//             className="border p-1 w-full bg-gray-100"
//             value={form.giver_address}
//             onChange={(e) => update("giver_address", e.target.value)}
//           />
//         </div>

//         <div className="flex gap-4">
//           <label>
//             <input
//               type="checkbox"
//               checked={form.payment_cash}
//               onChange={(e) => {
//                 update("payment_cash", e.target.checked);
//                 if (e.target.checked) update("payment_online", false);
//               }}
//             /> Cash
//           </label>

//           <label>
//             <input
//               type="checkbox"
//               checked={form.payment_online}
//               onChange={(e) => {
//                 update("payment_online", e.target.checked);
//                 if (e.target.checked) update("payment_cash", false);
//               }}
//             /> Online
//           </label>
//         </div>
// {(form.payment_cash || form.payment_online) && (
//   <div className="p-3 border bg-purple-50 rounded text-center">
//     {/* ONLINE QR CODE */}
//     {form.payment_online && (
//       <>
//         <p className="font-semibold mb-2 text-purple-900">
//           🟣 Online Payment Screenshot Upload
//         </p>
//         <img src="/qr.jpeg" alt="QR Code" className="w-40 mx-auto" />
//       </>
//     )}

//     {/* Instruction */}
//     <p className="text-xs mb-2">
//       कृपया पेमेंटचा स्क्रीनशॉट अपलोड करा.
//       Cash पेमेंटसाठी रिसीटचा स्क्रीनशॉट आवश्यक आहे.  
//       Online पेमेंटसाठी पेमेंटचा स्क्रीनशॉट आवश्यक आहे.
//     </p>

//     <input
//       type="file"
//       onChange={(e) => setScreenshot(e.target.files[0])}
//     />
//   </div>
// )}


//         <button
//           onClick={submitForm}
//           disabled={loading}
//           className="w-full bg-blue-600 text-white p-2 rounded"
//         >
//           {loading ? "Submitting..." : "Submit"}
//         </button>
//       </div>
//     </>
//   );
// }


import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const API_BASE = process.env.REACT_APP_API_URL || "/api";


// 🔹 CHANGE THESE TO YOUR DETAILS
const UPI_ID = "7020565710@kotak";
const PAYEE_NAME = "MERURAM INDIATAG PRIVATE LIMITED";
const PAYMENT_AMOUNT = "3000"; // change amount if needed


export default function LotteryRegistration() {
  const { ref } = useParams();

  const [form, setForm] = useState({
    receiver_name: "", receiver_aadhaar: "", receiver_address: "", receiver_mobile: "",
    giver_name: "", giver_mobile: "", giver_address: "",
    payment_cash: false, payment_online: false,
  });

  const [screenshot, setScreenshot] = useState(null);
  const [error, setError] = useState("");
  const [successData, setSuccessData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

 /* ─── UPI PAY FUNCTION ─── */
  const payNow = () => {
    const upiLink = `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
      PAYEE_NAME
    )}&am=${PAYMENT_AMOUNT}&cu=INR`;

    window.location.href = upiLink;
  };

  const update = (field, value) => setForm((p) => ({ ...p, [field]: value }));

  /* ─── Prefill giver on referral ─── */
  useEffect(() => {
    if (!ref) return;
    axios.get(`${API_BASE}/coupons/prefill/${ref}`)
      .then((res) => {
        if (res.data.success) {
          setForm((p) => ({ ...p, ...res.data.giver }));
        }
      })
      .catch(() => {});
  }, [ref]);

  /* ─── Validate ─── */
  const validate = () => {
    setError("");
    const required = ["receiver_name", "receiver_address", "receiver_mobile", "receiver_aadhaar", "giver_name", "giver_mobile", "giver_address"];
    for (const f of required) {
      if (!form[f].trim()) { setError("कृपया सर्व आवश्यक माहिती भरा."); return false; }
    }
    if (!/^\d{10}$/.test(form.receiver_mobile)) { setError("Receiver mobile must be 10 digits."); return false; }
    if (!/^\d{10}$/.test(form.giver_mobile))    { setError("Giver mobile must be 10 digits."); return false; }
    if (!/^\d{12}$/.test(form.receiver_aadhaar)) { setError("कृपया 12 अंकी आधार क्रमांक प्रविष्ट करा."); return false; }
    if (!form.payment_cash && !form.payment_online) { setError("Please select payment method."); return false; }
    if (!screenshot) { setError("कृपया पेमेंटचा स्क्रीनशॉट अपलोड करा."); return false; }
    return true;
  };

  /* ─── Submit ─── */
  const submitForm = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const fd = new FormData();
      Object.keys(form).forEach((k) => fd.append(k, form[k]));
      fd.append("screenshot", screenshot);
      const url = ref ? `${API_BASE}/coupons/register/${ref}` : `${API_BASE}/coupons/register`;
      const res = await axios.post(url, fd);
      if (res.data.success) {
        setSuccessData(res.data);
        toast.success("Registration successful!");
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  const copyLink = () => {
    if (!successData?.referral_link) return;
    navigator.clipboard.writeText(successData.referral_link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  /* ─── SUCCESS SCREEN ─── */
  if (successData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm text-center">
          <div className="text-5xl mb-3">🎉</div>
          <h2 className="text-2xl font-bold text-green-600 mb-1">फॉर्म सबमिट झाला!</h2>
          <p className="text-gray-600 text-sm mb-4">मंजुरीनंतर तुम्हाला SMS येईल.</p>
          <div className="bg-indigo-50 rounded-xl p-4 mb-4">
            <p className="text-xs text-gray-500 mb-1">Your Coupon Number</p>
            <div className="text-3xl font-black text-indigo-600 tracking-widest">{successData.coupon_number}</div>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-xs text-gray-500 break-all mb-3">{successData.referral_link}</div>
          <button onClick={copyLink} className="w-full bg-indigo-600 text-white py-2 rounded-lg font-semibold mb-2 hover:bg-indigo-700 transition">
            {copied ? "✅ Link Copied!" : "Referral Link Copy करा"}
          </button>
          <button
            onClick={() => {
              const wa = `https://wa.me/?text=${encodeURIComponent("Join with my referral link: " + successData.referral_link)}`;
              window.open(wa, "_blank");
            }}
            className="w-full bg-green-500 text-white py-2 rounded-lg font-semibold hover:bg-green-600 transition"
          >
            📱 WhatsApp वर शेअर करा
          </button>
        </div>
      </div>
    );
  }

  /* ─── FORM ─── */
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        

        <div className="bg-white rounded-2xl shadow-lg p-6 space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-lg">{error}</div>
          )}

          {/* RECEIVER */}
          <div className="border-b pb-4">
            <h3 className="font-semibold text-gray-700 mb-3 text-sm">👤 Receiver Information</h3>
            {[
              { label: "कुपन घेणाऱ्याचे नाव / Receiver Name", field: "receiver_name" },
              { label: "पत्ता / Address", field: "receiver_address" },
            ].map(({ label, field }) => (
              <div key={field} className="mb-3">
                <label className="text-xs text-gray-600 block mb-1">{label}</label>
                <input
                  className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                  value={form[field]}
                  onChange={(e) => update(field, e.target.value)}
                />
              </div>
            ))}
            <div className="mb-3">
              <label className="text-xs text-gray-600 block mb-1">आधार क्रमांक / Aadhaar (12 digits)</label>
              <input
                maxLength={12}
                className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                value={form.receiver_aadhaar}
                onChange={(e) => update("receiver_aadhaar", e.target.value.replace(/\D/g, ""))}
              />
            </div>
            <div>
              <label className="text-xs text-gray-600 block mb-1">मो. नं. / Mobile</label>
              <input
                maxLength={10}
                className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                value={form.receiver_mobile}
                onChange={(e) => update("receiver_mobile", e.target.value.replace(/\D/g, ""))}
              />
            </div>
          </div>

          {/* GIVER */}
          <div className="border-b pb-4">
            <h3 className="font-semibold text-gray-700 mb-3 text-sm">🤝 Giver Information</h3>
            {[
              { label: "कुपन देणाऱ्याचे नाव / Giver Name", field: "giver_name" },
              { label: "पत्ता / Giver Address", field: "giver_address" },
            ].map(({ label, field }) => (
              <div key={field} className="mb-3">
                <label className="text-xs text-gray-600 block mb-1">{label}</label>
                <input
                  disabled={!!ref}
                  className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-400 disabled:cursor-not-allowed"
                  value={form[field]}
                  onChange={(e) => update(field, e.target.value)}
                />
              </div>
            ))}
            <div>
              <label className="text-xs text-gray-600 block mb-1">मो. नं. / Giver Mobile</label>
              <input
                maxLength={10}
                disabled={!!ref}
                className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm bg-gray-50 disabled:cursor-not-allowed"
                value={form.giver_mobile}
                onChange={(e) => update("giver_mobile", e.target.value.replace(/\D/g, ""))}
              />
            </div>
          </div>

          
        {/* PAYMENT SECTION */}
        <div>
          <h3 className="font-semibold mb-3">💳 Payment Method</h3>

          <div className="flex gap-6 mb-4">
            {/* CASH */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={form.payment_cash}
                onChange={(e) => {
                  update("payment_cash", e.target.checked);
                  if (e.target.checked) update("payment_online", false);
                }}
                className="w-4 h-4"
              />
              💵 Cash
            </label>

            {/* ONLINE */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={form.payment_online}
                onChange={(e) => {
                  update("payment_online", e.target.checked);
                  if (e.target.checked) update("payment_cash", false);
                }}
                className="w-4 h-4"
              />
              📱 Online
            </label>
          </div>

          {(form.payment_cash || form.payment_online) && (
            <div className="bg-purple-50 border rounded-xl p-4">

              {form.payment_online && (
                <>
                  <div className="text-center mb-4">
                    <p className="text-sm font-semibold mb-2">
                      Scan QR to Pay
                    </p>
                    <img
                      src="/qr.jpeg"
                      alt="QR"
                      className="w-40 mx-auto rounded shadow"
                    />
                  </div>

                  <button
                    onClick={payNow}
                    className="w-full bg-green-600 text-white py-2 rounded-lg font-semibold mb-4 hover:bg-green-700"
                  >
                    🚀 Pay Now via UPI
                  </button>
                </>
              )}

              <p className="text-xs text-center mb-2">
                Upload payment screenshot
              </p>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => setScreenshot(e.target.files[0])}
                className="text-xs"
              />
            </div>
          )}
        </div>

        <button
          onClick={submitForm}
          disabled={loading}
          className="w-full bg-indigo-600 text-white py-3 rounded-xl font-bold"
        >
          {loading ? "Submitting..." : "🎟️ Register Now"}
        </button>
      </div>
    </div>
    </div>
  );
}
